<template>
  <t-modal
    v-model="isVisible"
    @closed="onModalClosed"
    name="edit-hours-modal"
  >
    <!-- TODO make "Business" dynamic based on user type -->
    <h2 class="inline-block">Set {{ this.hourType }} Hours</h2>
    <h4 class="float-right inline-block">Closed</h4>
    <div class="mt-4">
      <ValidationObserver
        ref="observer"
        v-slot="{ invalid }"
      >
        <form @submit.prevent="onSubmit">
          <div class="flex items-center mb-5">
            <div class="w-24 font-bold">
              Monday
            </div>

            <div>
              <ValidationProvider
                rules="time|timeBefore:@endTimeMonday|requiredIf:@endTimeMonday"
                v-slot="{classes, errors}"
                vid="startTimeMonday"
                name="Start time"
              >
                <div
                  class="control"
                  :class="classes"
                >
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.monday.start"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.monday.start"
                    class="mr-3"
                    placeholder="Start Time"
                    initialTime="09:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>

            <div>
              <ValidationProvider
                rules="time|requiredIf:@startTimeMonday"
                v-slot="{errors}"
                vid="endTimeMonday"
                name="End time"
              >
                <div class="control">
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.monday.end"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.monday.end"
                    class="mr-3"
                    placeholder="End Time"
                    initialTime="17:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>

            <div>
              <input class="red-checkbox form-check-input"  type="checkbox" :value="hours.monday.closed" v-model="hours.monday.closed" id="mondayClosedCheck" title="Closed" />
            </div>
          </div>

          <div class="flex items-center mb-5">
            <div class="w-24 font-bold">
              Tuesday
            </div>

            <div>
              <ValidationProvider
                rules="time|timeBefore:@endTimeTuesday|requiredIf:@endTimeTuesday"
                v-slot="{classes, errors}"
                vid="startTimeTuesday"
                name="Start time"
              >
                <div
                  class="control"
                  :class="classes"
                >
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.tuesday.start"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.tuesday.start"
                    class="mr-3"
                    placeholder="Start Time"
                    initialTime="09:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>

            <div>
              <ValidationProvider
                rules="time|requiredIf:@startTimeTuesday"
                v-slot="{errors}"
                vid="endTimeTuesday"
                name="End time"
              >
                <div class="control">
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.tuesday.end"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.tuesday.end"
                    class="mr-3"
                    placeholder="End Time"
                    initialTime="17:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>

            <div>
              <input class="red-checkbox form-check-input"  type="checkbox" :value="hours.tuesday.closed" v-model="hours.tuesday.closed" id="tuesdayClosedCheck" title="Closed" />
            </div>
          </div>

          <div class="flex items-center mb-5">
            <div class="w-24 font-bold">
              Wednesday
            </div>

            <div>
              <ValidationProvider
                rules="time|timeBefore:@endTimeWednesday|requiredIf:@endTimeWednesday"
                v-slot="{classes, errors}"
                vid="startTimeWednesday"
                name="Start time"
              >
                <div
                  class="control"
                  :class="classes"
                >
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.wednesday.start"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.wednesday.start"
                    class="mr-3"
                    placeholder="Start Time"
                    initialTime="09:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>

            <div>
              <ValidationProvider
                rules="time|requiredIf:@startTimeWednesday"
                v-slot="{errors}"
                vid="endTimeWednesday"
                name="End time"
              >
                <div class="control">
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.wednesday.end"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.wednesday.end"
                    class="mr-3"
                    placeholder="End Time"
                    initialTime="17:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>

            <div>
              <input class="red-checkbox form-check-input"  type="checkbox" :value="hours.wednesday.closed" v-model="hours.wednesday.closed" id="wednesdayClosedCheck" title="Closed" />
            </div>
          </div>

          <div class="flex items-center mb-5">
            <div class="w-24 font-bold">
              Thursday
            </div>

            <div>
              <ValidationProvider
                rules="time|timeBefore:@endTimeThursday|requiredIf:@endTimeThursday"
                v-slot="{classes, errors}"
                vid="startTimeThursday"
                name="Start time"
              >
                <div
                  class="control"
                  :class="classes"
                >
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.thursday.start"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.thursday.start"
                    class="mr-3"
                    placeholder="Start Time"
                    initialTime="09:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>

            <div>
              <ValidationProvider
                rules="time|requiredIf:@startTimeThursday"
                v-slot="{errors}"
                vid="endTimeThursday"
                name="End time"
              >
                <div class="control">
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.thursday.end"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.thursday.end"
                    class="mr-3"
                    placeholder="End Time"
                    initialTime="17:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>
            <div>
              <input class="red-checkbox form-check-input"  type="checkbox" :value="hours.thursday.closed" v-model="hours.thursday.closed" id="thursdayClosedCheck" title="Closed" />
            </div>
          </div>

          <div class="flex items-center mb-5">
            <div class="w-24 font-bold">
              Friday
            </div>

            <div>
              <ValidationProvider
                rules="time|timeBefore:@endTimeFriday|requiredIf:@endTimeFriday"
                v-slot="{classes, errors}"
                vid="startTimeFriday"
                name="Start time"
              >
                <div
                  class="control"
                  :class="classes"
                >
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.friday.start"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.friday.start"
                    class="mr-3"
                    placeholder="Start Time"
                    initialTime="09:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>

            <div>
              <ValidationProvider
                rules="time|requiredIf:@startTimeFriday"
                v-slot="{errors}"
                vid="endTimeFriday"
                name="End time"
              >
                <div class="control">
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.friday.end"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.friday.end"
                    class="mr-3"
                    placeholder="End Time"
                    initialTime="17:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>
            <div>
              <input class="red-checkbox form-check-input"  type="checkbox" :value="hours.friday.closed" v-model="hours.friday.closed" id="fridayClosedCheck" title="Closed" />
            </div>
          </div>

          <div class="flex items-center mb-5">
            <div class="w-24 font-bold">
              Saturday
            </div>

            <div>
              <ValidationProvider
                rules="time|timeBefore:@endTimeSaturday|requiredIf:@endTimeSaturday"
                v-slot="{classes, errors}"
                vid="startTimeSaturday"
                name="Start time"
              >
                <div
                  class="control"
                  :class="classes"
                >
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.saturday.start"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.saturday.start"
                    class="mr-3"
                    placeholder="Start Time"
                    initialTime="09:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>

            <div>
              <ValidationProvider
                rules="time|requiredIf:@startTimeSaturday"
                v-slot="{errors}"
                vid="endTimeSaturday"
                name="End time"
              >
                <div class="control">
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.saturday.end"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.saturday.end"
                    class="mr-3"
                    placeholder="End Time"
                    initialTime="17:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>
            <div>
              <input class="red-checkbox form-check-input"  type="checkbox" :value="hours.saturday.closed" v-model="hours.saturday.closed" id="saturdayClosedCheck" title="Closed" />
            </div>
          </div>

          <div class="flex items-center mb-5">
            <div class="w-24 font-bold">
              Sunday
            </div>

            <div>
              <ValidationProvider
                rules="time|timeBefore:@endTimeSunday|requiredIf:@endTimeSunday"
                v-slot="{classes, errors}"
                vid="startTimeSunday"
                name="Start time"
              >
                <div
                  class="control"
                  :class="classes"
                >
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.sunday.start"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.sunday.start"
                    class="mr-3"
                    placeholder="Start Time"
                    initialTime="09:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>

              </ValidationProvider>
            </div>

            <div>
              <ValidationProvider
                rules="time|requiredIf:@startTimeSunday"
                v-slot="{errors}"
                vid="endTimeSunday"
                name="End time"
              >
                <div class="control">
                  <t-datepicker
                    user-format="G:i K"
                    date-format="G:i K"
                    :value="hours.sunday.end"
                    timepicker
                    :datepicker="false"
                    am-pm
                    v-model="hours.sunday.end"
                    class="mr-3"
                    placeholder="End Time"
                    initialTime="17:00"
                  />
                  <span class="absolute text-hint text-salesium-red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <div>
              <input class="red-checkbox form-check-input"  type="checkbox" :value="hours.sunday.closed" v-model="hours.sunday.closed" id="sundayClosedCheck" title="Closed" />
            </div>
          </div>

          <div class="flex mt-4 justify-end">
            <button
              class="primary-btn mr-3"
              type="submit"
              title="Save Changes"
              :disabled="invalid"
            >Save Changes</button>
            <button
              class="secondary-btn"
              type="button"
              @click.prevent="$modal.hide('edit-hours-modal')"
            >Cancel</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </t-modal>
</template>

<script>
// The reason that each day is not a separate component is because the ValidationObserver has to be wrapped around the Validation Provider to allow cross field validation
import { ValidationObserver, ValidationProvider } from 'vee-validate';
export default {
    props: ['modalVisible', 'hourType'],
    data() {
        return {
            isVisible: this.modalVisible,
            hours: {
                type: null,
                monday: {
                    start: null,
                    end: null,
                    closed: false,
                },
                tuesday: {
                    start: null,
                    end: null,
                    closed: false,
                },
                wednesday: {
                    start: null,
                    end: null,
                    closed: false,
                },
                thursday: {
                    start: null,
                    end: null,
                    closed: false,
                },
                friday: {
                    start: null,
                    end: null,
                    closed: false,
                },
                saturday: {
                    start: null,
                    end: null,
                    closed: false,
                },
                sunday: {
                    start: null,
                    end: null,
                    closed: false,
                },
            },
        };
    },
    watch: {
        modalVisible() {
            if (this.isVisible !== this.modalVisible) {
                this.isVisible = this.modalVisible;
            }
        },
    },
    methods: {
        onModalClosed() {
            this.$emit('modalHidden');
        },
        onTimeChanged(event) {
            this.hours[event.day][event.label] = event.time;
        },
        async onSubmit() {
            // TODO: submit form, if successful, close modal

            this.hours.type = this.hourType
            if( this.hourType === 'Business')
            {
              axios.post('/SetBusinessHours', this.hours )
              .then((response) => {
                console.log(response);
              })
              .catch((error) => {
                console.log(error)
              })
            }
            else
            {
              axios.post('/SetContactHours', this.hours).then((response) => {
                console.log(response);
              }).then((response) => {
                console.log(response)
              })
              .catch((error) => {
                console.log(error)
              })
            }

            const isValid = await this.$refs.observer.validate();
            if (isValid) {
              setTimeout(() => {
                this.$modal.hide('edit-hours-modal');
                this.$toasted.global.toast_success(
                  'Hours updated'
                );
                this.$emit('hoursUpdated', this.hours);
              }, 500);
            }
        },
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
};
</script>